import PropTypes from 'prop-types';
import React from 'react';

import { Button } from 'components/Button';
import { List, Pane } from './Component/styles';
import { useAttachsParams } from 'providers/attachs-params';
import Item from '../Item';

export default function ListInline(props) {
    const { attachsCountTotal, list, toggleAllAttachs, ...otherProps } = props;
    const { selectors } = useAttachsParams();

    return (
        <Pane id={`${selectors.emlAttachments}_pane`} {...otherProps}>
            <List className='attach-list'>
                {list.map((item, idx) => (
                    <Item itemData={{...item, itemIdx:idx}} key={item.hashId} />
                ))}
                {list.length < attachsCountTotal && (
                    <div className='btn-container'>
                        <Button className='btn_show-all' onClick={toggleAllAttachs}>
                            {`+ ${attachsCountTotal - list.length}`}
                        </Button>
                    </div>
                )}
            </List>
        </Pane>
    );
}

ListInline.propTypes = {
    attachsCountTotal: PropTypes.number.isRequired,
    list: PropTypes.array.isRequired,
    toggleAllAttachs: PropTypes.func.isRequired
};
